import React, { FC, useContext } from 'react'
import ManageContext from '../contexts/manage'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'

import Form from '@kaidam/fc-frontend/src/components/form/Wrapper'
import {
  crmValidation,
} from '@kaidam/fc-frontend/src/components/booking/forms'

import {
  formSchema,
  emptyValues,
} from '@kaidam/fc-frontend/src/components/crm/forms'

const ManageDetails: FC<React.PropsWithChildren<unknown>> = () => {
  const manage = useContext(ManageContext)

  return (
    <Box sx={{
      display: 'flex',
    }}>
      <Box sx={{
        width: '100%',
        padding: '24px',
      }}>
        <Form
          validationSchema={ crmValidation }         
          error={ "" }
          initialValues={ manage.data.booking.data.crm }
          onSubmit={ (crm) => {
            manage.update({
              crm,
            })
          } }
        >
          {
            ({
              render,
              setFieldValue,
              values,
              showErrors,
              errors,
              isValid,
              onSubmit,
            }) => {
              return (
                <div>
                  {
                    render(formSchema)
                  }
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={ onSubmit }
                  >
                    Update
                  </Button>
                </div>
              )
            }
          }               
        </Form>
      </Box>
    </Box>
  )
}

export default ManageDetails